// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"1b599277","2744":"7c9d415b","3905":"e4246e0a","5106":"101d25e6","5672":"81a9fb01","5687":"de9a35c2"}[chunkId] + ".chunk.css";
};